import React from "react"
import PropTypes from "prop-types"
import { Card, CardBody, CardTitle, Media, Alert } from "reactstrap"
import { map } from "lodash"
import { isEmpty } from "lodash"
import { getUserRole } from "components/Common/Roles"

const BirthReport = ({ reportJson }) => {
  let reportObject = JSON.parse(reportJson);
  let userRoles = getUserRole()
  return (
    <Card>
      <CardBody>
        <CardTitle className="mb-4">
          <Alert color="info" className="mb-0" role="alert">
            Report Summary
          </Alert>
        </CardTitle>
        <div color="info">
          <ul className="verti-timeline list-unstyled">
            {map(reportObject, (report, k) => (
              <div key={"_user_" + k}>
                {!isEmpty(report.description) && (
                  <li className="event-list" >
                    <div className="event-timeline-dot">
                      <i className="bx bx-right-arrow-circle"></i>
                    </div>
                    <Media body>
                      <div>
                        {userRoles.productAdmin && (
                          <h5>
                            {report.descriptionTitle}
                          </h5>
                        )}
                        {!isEmpty(report.description) && (
                          <p className="text-muted">
                            {report.description}
                          </p>
                        )}
                      </div>
                    </Media>
                  </li>
                )}
              </div>
            ))}
          </ul>
        </div>
      </CardBody>
    </Card >
  )
}

BirthReport.propTypes = {
  options: PropTypes.object,
  series: PropTypes.array,
}

export default BirthReport
